import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import Home from '../view/index';
import About from '../view/about';

export default new Router({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '/',
      name: 'index',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/info',
      name: 'info',
      component: resolve => require(['../view/info'], resolve)
    },
    {
      path: '/infolist',
      name: 'infolist',
      component: resolve => require(['../view/infolist'], resolve)
    },
    {
      path: '/product',
      name: 'product',
      component: resolve => require(['../view/product'], resolve)
    },
    {
      path: '/culture',
      name: 'culture',
      component: resolve => require(['../view/culture'], resolve)
    },
    {
      path: '/news',
      name: 'news',
      component: resolve => require(['../view/news'], resolve)
    },
    {
      path: '/article',
      name: 'article',
      component: resolve => require(['../view/article'], resolve)
    },
    {
      path: '/hr',
      name: 'hr',
      component: resolve => require(['../view/hr'], resolve)
    },
    {
      path: '/jd',
      name: 'jd',
      component: resolve => require(['../view/jd'], resolve)
    },
    {
      path: '/resume',
      name: 'resume',
      component: resolve => require(['../view/resume'], resolve)
    },
    {
      path: '/ux',
      name: 'ux',
      component: resolve => require(['../view/ux'], resolve)
    },
    {
       path: '/author',
       name: 'author',
       component: resolve => require(['../view/author'], resolve)
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['../view/login'], resolve)
    },
    {
      path: '/uppwd',
      name: 'uppwd',
      component: resolve => require(['../view/uppwd'], resolve)
    },
    {
      path: '/stars',
      name: 'stars',
      component: resolve => require(['../view/stars'], resolve)
    },
    {
      path: '/starinfo',
      name: 'starinfo',
      component: resolve => require(['../view/starinfo'], resolve)
    },
    {
      path: '/window',
      name: 'window',
      component: resolve => require(['../view/window'], resolve)
    },
    {
      path: '/timeline',
      name: 'timeline',
      component: resolve => require(['../view/timeline'], resolve)
    },
    {
      path: '/windowview',
      name: 'windowview',
      component: resolve => require(['../view/windowview'], resolve)
    },
    {
      path: '/psq',
      name: 'psq',
      component: resolve => require(['../view/psq'], resolve)
    },
    {
      path: '/qform',
      name: 'qform',
      component: resolve => require(['../view/qform'], resolve)
    },
    {
      path: '/guess',
      name: 'guess',
      component: resolve => require(['../view/guess'], resolve)
    },
    {
      path: '/gform',
      name: 'gform',
      component: resolve => require(['../view/gform'], resolve)
    },
    {
      path: '/over',
      name: 'over',
      component: resolve => require(['../view/over'], resolve)
    },
    {
      path: '/top',
      name: 'top',
      component: resolve => require(['../view/top'], resolve)
    },
    {
      path: '/my',
      name: 'my',
      component: resolve => require(['../view/my'], resolve)
    },
    {
      path: '/myq',
      name: 'myq',
      component: resolve => require(['../view/myq'], resolve)
    },
    {
      path: '/myg',
      name: 'myg',
      component: resolve => require(['../view/myg'], resolve)
    },
    {
      path: '/mya',
      name: 'mya',
      component: resolve => require(['../view/mya'], resolve)
    },
    {
      path: '/myback',
      name: 'myback',
      component: resolve => require(['../view/myback'], resolve)
    },
    {
      path: '/us',
      name: 'us',
      component: resolve => require(['../view/us'], resolve)
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: resolve => require(['../view/us'], resolve)
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js